import { render, staticRenderFns } from "./MyDeals.vue?vue&type=template&id=91ab2900&scoped=true"
import script from "./MyDeals.vue?vue&type=script&lang=js"
export * from "./MyDeals.vue?vue&type=script&lang=js"
import style0 from "./MyDeals.vue?vue&type=style&index=0&id=91ab2900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91ab2900",
  null
  
)

export default component.exports